import { markStale, markUpToDate } from 'console/idle/reducer';
import { applyDevicesJson } from 'console/redux/devices/items/actions';
import { getIdleState } from 'console/idle/selectors';
export const reloadDevice = () => async (dispatch, getState, { api }) => {
    dispatch(markStale());
    let devices = [];
    if (getIdleState(getState()) === false) {
        try {
            const response = await api.request_devices();
            devices = response.devices;
            // break;
        }
        catch (e) {
            console.error(`Can't reload devices`);
            // async version of sleep(delay)
            // await new Promise((resolve) => setTimeout(resolve, delay));
        }
    }
    try {
        if (devices.length) {
            dispatch(applyDevicesJson(devices));
        }
    }
    finally {
        dispatch(markUpToDate());
    }
};
